<template>
    <div>
        <Banner :banners="banners" show-overlay class="white"> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper white">
            <h2 class="title text-center title-align">負碳拚拚看</h2>
            <div>
                <p class="carbon-text-sm subtitleWrapper">
                    恭喜你完成了碳足跡標籤的拼圖！<br>再多認識其他負碳商品有關的標章吧！
                </p>
            </div>
            <MarkLayout :markList="markList" />
            <div class="pagination">
                <button @click.prevent="goView('/carbon/certificationMark')">
                    &#10094;
                </button>
                <span>2/2</span>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import MarkLayout from '@/components/markLayout';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            markList: [
                {
                    title: '環保標章',
                    imgUrl: require('@/assets/環保標章.jpg'),
                    imgWidth: 'width:150px',
                    content: '環保標章是以「一片綠色樹葉包裹著純淨、不受污染的地球」為設計，廠商產品經認可符合環保標章規格標準者，即可於產品或包裝上標示環保標章圖樣，供民眾採購辨識，透過環保標章制度，鼓勵廠商降低環境污染及節省資源消耗，促進廢棄物之減量及回收再利用，同時喚醒消費者慎選可回收、低污染、省資源之產品，以提昇環境品質。',
                },
                {
                    title: '節能標章',
                    imgUrl: require('@/assets/節能標章.jpg'),
                    imgWidth: 'width:150px',
                    content: '電源、愛心雙手、生生不息的火苗，所組成的標誌，就是節能標章。心形及手的圖案意指用心節約、實踐省油省氣省電，紅色火苗代表可燃油氣，電源插座代表生活用電，倡導國人響應節能從生活中的點滴做起。<br>產品貼上這個圖樣，代表能源效率比國家認證標準高10-50%，不但品質有保障，更省能省錢。希望藉由節能標章制度的推廣，鼓勵民眾使用高能源效率產品，以減少能源消耗。',
                },
            ],
        };
    },
    components: {
        Banner,
        Breadcrumb,
        MarkLayout,
    },
    methods: {
        goView(link) {
            this.$router.push(link).catch(() => { });
        },
    },
    mixins: [coreMixin],
};
</script>

<style lang="sass" scoped>
.selectStyle
    width: 100%
.subtitleWrapper
    padding: 12px 0
.pagination
    display: flex
    justify-content: center
    align-items: center
    padding: 24px 0
span
    padding: 0 24px
    font-weight: 700
    font-size: 14px
button
    border: none
    background-color: transparent
    color: #ccc
</style>
